import Provider from "./Provider-Api";
import CheckApi from "./check-api";

// Housekeeping MANAGEMENT

export const housekeepingGetHousekeepingByTime = async (data, token) => {
    CheckApi('getHousekeepingByTime', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/getHousekeepingByTime",
        data,
        token
    });
    CheckApi('dataRes-getHousekeepingByTime', dataRes)
    return dataRes;
};

export const housekeepingGetHousekeepingByTimeAndBed = async (data, token) => {
    CheckApi('getHousekeepingByTimeAndBed', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/getHousekeepingByTimeAndBed",
        data,
        token
    });
    CheckApi('dataRes-getHousekeepingByTimeAndBed', dataRes)
    return dataRes;
};

export const housekeepingGetCheckHousekeepingByTimeAndBed = async (data, token) => {
    CheckApi('getCheckHousekeepingByTimeAndBed', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/getCheckHousekeepingByTimeAndBed",
        data,
        token
    });
    CheckApi('dataRes-getCheckHousekeepingByTimeAndBed', dataRes)
    return dataRes;
};

export const housekeepingGetSearchHousekeepingByTime = async (data, token) => {
    CheckApi('getSearchHousekeepingByTime', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/getSearchHousekeepingByTime",
        data,
        token
    });
    CheckApi('dataRes-getSearchHousekeepingByTime', dataRes)
    return dataRes;
};


export const housekeepingGetSearchHousekeepingByTimeAndBed = async (data, token) => {
    CheckApi('getSearchHousekeepingByTimeAndBed', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/getSearchHousekeepingByTimeAndBed",
        data,
        token
    });
    CheckApi('dataRes-getSearchHousekeepingByTimeAndBed', dataRes)
    return dataRes;
};

export const housekeepingGetHousekeeping = async (data, token) => {
    CheckApi('getHousekeeping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/getHousekeeping",
        data,
        token
    });
    CheckApi('dataRes-getHousekeeping', dataRes)
    return dataRes;
};

export const housekeepingAddHousekeeping = async (data, token) => {
    CheckApi('addHousekeeping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/addHousekeeping",
        data,
        token
    });
    CheckApi('dataRes-addHousekeeping', dataRes)
    return dataRes;
};

export const housekeepingDeleteHousekeeping = async (item, token) => {
    CheckApi('deleteHousekeeping', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/deleteHousekeeping",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteHousekeeping', dataRes)
    return dataRes;
};

export const housekeepingUpdateHousekeeping = async (data, token) => {
    CheckApi('updateHousekeeping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/updatehousekeeping",
        data,
        token
    });
    CheckApi('dataRes-updateHousekeeping', dataRes)
    return dataRes;
};

export const housekeepingUpdateChangeStatusHousekeeping = async (data, token) => {
    CheckApi('updateChangeStatusHousekeeping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/housekeeping/updateChangeStatusHousekeeping",
        data,
        token
    });
    CheckApi('dataRes-updateChangeStatusHousekeeping', dataRes)
    return dataRes;
};

// END Housekeeping MANAGEMENT